import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-[#050605] flex items-center justify-center p-6" data-testid="payment-cancel">
      <div className="glass-card p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-[#ef4444] mx-auto mb-4" />
        <h1 className="font-['Barlow_Condensed'] text-2xl font-bold uppercase tracking-wider text-white mb-2">
          Payment Cancelled
        </h1>
        <p className="text-[#8a948a] mb-6">
          Your payment was cancelled. No charges were made to your account.
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/subscription">
            <Button className="btn-gold w-full">
              Try Again
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button variant="ghost" className="btn-ghost w-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
